export const resources = {
  EditorFilterItemRemoveTitle: '',
  EditorFilterItemAddTitle: ''
};
